import { Component, OnDestroy } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { FrequencyIntervalComponent } from './frequency-interval/frequency-interval.component';
import { FrequencyOnlyComponent } from './frequency-only/frequency-only.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { FrequencyDrawerParams } from '../../insights-data.interface';
import { DrawerService } from '../../../../../../core/services/drawer.service';

@Component({
  selector: 'app-frequency',
  standalone: true,
  imports: [
    NzTabsModule,
    FrequencyIntervalComponent,
    FrequencyOnlyComponent,
    NzButtonModule,
  ],
  templateUrl: './frequency.component.html',
  styleUrl: './frequency.component.scss',
})
export class FrequencyComponent implements OnDestroy {
  selectedTabIndex = 0;
  private readonly destroy$ = new Subject<void>();
  drawerParmas: FrequencyDrawerParams = {} as FrequencyDrawerParams;
  constructor(private drawerService: DrawerService) {
    this.setupDrawerSubscription();
  }
  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }
  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<FrequencyDrawerParams>(DRAWER_IDS.FREQUENCY)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.drawerParmas = params;
          this.selectedTabIndex = this.drawerParmas.selectedRow.isFrequencyOnly
            ? 1
            : 0;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
